export default {
  'RegistrationStepper.back': { en: 'Back', fr: 'Retour' },
  'RegistrationStepper.next': { en: 'Next', fr: 'Suivant' },
  'RegistrationStepper.finish': { en: 'Finish', fr: 'Terminer' },
};
